"use client";

import { c as _c } from "react/compiler-runtime";
import { Disclosure, Tab } from "@headlessui/react";
import { PiCaretDown, PiChatCircleDots, PiEnvelopeSimple, PiWhatsappLogo } from "react-icons/pi";
type FaqItem = {
  question: string;
  answer: string;
};
const buyerFaqs: FaqItem[] = [{
  question: "1. ¿Qué es Lealti?",
  answer: "Lealti es un marketplace curado de moda, accesorios y lifestyle donde podés descubrir y comprar productos de distintas marcas dentro de una sola experiencia."
}, {
  question: "2. ¿Puedo comprar productos de varias marcas en un mismo pedido?",
  answer: "Sí. Ese es uno de los diferenciales de Lealti: podés agregar productos de distintas marcas a un mismo carrito y completar una sola compra."
}, {
  question: "3. ¿Quién me vende el producto: Lealti o la marca?",
  answer: "Depende del caso. En general, Lealti opera como plataforma de marketplace y la marca es la vendedora de su producto, salvo que en una operación específica Lealti se identifique expresamente como vendedor. Esa información debe quedar visible en el flujo de compra o en la documentación del pedido."
}, {
  question: "4. ¿Las marcas que veo en Lealti son oficiales?",
  answer: "Lealti trabaja con marcas y tiendas verificadas dentro de su ecosistema. Además de la curaduría comercial, Compra Segura cubre supuestos de disconformidad material o problemas de autenticidad cuando el producto haya sido ofrecido como oficial o auténtico."
}, {
  question: "5. ¿Necesito crear una cuenta para comprar?",
  answer: "No siempre, pero crear una cuenta te da una experiencia más completa: seguimiento de pedidos, historial, favoritos y comunicaciones centralizadas."
}, {
  question: "6. ¿Qué métodos de pago aceptan?",
  answer: "Los métodos disponibles se muestran en el checkout y pueden variar según país, destino o dispositivo. Si un medio de pago requiere validaciones adicionales, la orden puede quedar sujeta a revisión."
}, {
  question: "7. ¿Los pagos son seguros?",
  answer: "Sí. Lealti trabaja con pasarelas o proveedores de pago especializados y no debería almacenar datos completos de tarjeta cuando el procesamiento lo realiza el proveedor correspondiente."
}, {
  question: "8. ¿Puedo guardar favoritos o wishlist?",
  answer: "Sí, cuando esa funcionalidad esté disponible en tu cuenta o en la app."
}, {
  question: "9. ¿Cómo sé cuándo llega mi pedido?",
  answer: "Vas a recibir actualizaciones de estado y, cuando corresponda, tracking. En pedidos multibrand, es posible que distintos productos viajen por separado."
}, {
  question: "10. ¿Hacen envíos internacionales?",
  answer: "Sí, Lealti comunica alcance a clientes locales e internacionales. Los destinos habilitados, costos, tiempos y eventuales cargos aduaneros se informan en el checkout o durante el proceso logístico."
}, {
  question: "11. ¿Tengo que pagar impuestos o aranceles al recibir mi compra?",
  answer: "En compras internacionales, puede pasar. Depende del país de destino, la categoría del producto y la normativa aduanera local. Cuando sea posible, Lealti lo informará antes de pagar; en otros casos, el cargo puede surgir al ingreso al país."
}, {
  question: "12. ¿Qué pasa si compro algo y después resulta que no había stock?",
  answer: "Si no se puede cumplir el pedido por falta real de stock, Lealti te va a contactar para ofrecerte una alternativa o gestionar el reembolso correspondiente."
}, {
  question: "13. ¿Puedo cancelar una compra?",
  answer: "Podés solicitar una cancelación antes de que el pedido entre en preparación o despacho, pero la posibilidad concreta dependerá del estado del pedido y de la normativa aplicable. Además, cuando tu ley local te otorgue derecho de retracto o arrepentimiento, ese derecho prevalece."
}, {
  question: "14. ¿Puedo devolver un producto?",
  answer: "Sí, en la medida en que aplique la política de devoluciones de Lealti y la ley obligatoria de tu país. Si comprás a distancia desde Uruguay, por ejemplo, el MEF informa un derecho de retracto de 5 días hábiles."
}, {
  question: "15. ¿Qué hago si el pedido llega dañado, equivocado o incompleto?",
  answer: "Tenés que contactar a soporte lo antes posible, idealmente dentro de las primeras 72 horas, con tu número de pedido y fotos o video del paquete y del producto. Lealti va a abrir un caso de Compra Segura."
}, {
  question: "16. ¿Qué cubre Compra Segura?",
  answer: "No entrega, daños en tránsito, producto equivocado, faltantes y diferencias materiales con lo publicado, entre otros casos previstos en la política."
}, {
  question: "17. ¿Cuánto demora un reembolso?",
  answer: "Depende del medio de pago y del banco o emisor, pero una vez aprobado el caso, Lealti o el vendedor responsable deberían procesarlo dentro de un plazo razonable."
}, {
  question: "18. ¿Cómo me contacto con soporte?",
  answer: "Lealti hoy comunica soporte centralizado por chat, email y WhatsApp, y su página pública de soporte indica disponibilidad todos los días, las 24 horas."
}, {
  question: "19. ¿Puedo modificar la dirección de entrega después de comprar?",
  answer: "A veces sí, pero sólo si el pedido todavía no fue procesado o despachado. Una vez emitida la etiqueta o iniciado el traslado, el cambio puede no ser posible."
}, {
  question: "20. ¿Qué pasa si mi pedido se divide en varios envíos?",
  answer: "No hay problema: significa que los productos salen desde marcas, depósitos o tiempos distintos. Vas a seguir viendo el estado general y cada tramo del pedido cuando corresponda."
}];
const brandFaqs: FaqItem[] = [{
  question: "1. ¿Qué tipo de marcas pueden sumarse?",
  answer: "Marcas de moda, accesorios y lifestyle alineadas con la curaduría y estándares de Lealti."
}, {
  question: "2. ¿Cómo es el proceso para entrar?",
  answer: "La marca se postula, comparte información de catálogo y assets, y pasa por un onboarding comercial y operativo."
}, {
  question: "3. ¿Tengo que subir todo mi catálogo?",
  answer: "No necesariamente. En Lealti suele funcionar mejor un edit claro: héroes, best sellers, cápsulas y producto fácil de leer."
}, {
  question: "4. ¿Quién maneja el stock?",
  answer: "La marca es responsable por la exactitud del stock, salvo flujos automatizados acordados con Lealti."
}, {
  question: "5. ¿Puedo sincronizar mi tienda?",
  answer: "Si tu e-commerce fue desarrollado o integrado con Lealti, la sincronización puede automatizar parte de la operación."
}, {
  question: "6. ¿Cómo funcionan pagos y liquidaciones?",
  answer: "Las condiciones económicas vigentes se comparten en onboarding y quedan reflejadas en el acuerdo comercial."
}, {
  question: "7. ¿Quién atiende al cliente final?",
  answer: "Lealti puede centralizar la primera línea de soporte, mientras que la marca acompaña lo relativo a producto, cambios, garantías e incidencias según SLA."
}, {
  question: "8. ¿Puedo participar en campañas y acciones editoriales?",
  answer: "Sí. Lealti puede impulsar campañas, edits, drops, activaciones y contenidos especiales junto a marcas seleccionadas."
}, {
  question: "9. ¿Necesito exclusividad?",
  answer: "No necesariamente. Eso depende del acuerdo puntual."
}, {
  question: "10. ¿Qué necesito para publicar bien?",
  answer: "Fotos consistentes, nombres claros, medidas, composición, stock real y tiempos de despacho confiables."
}];
const tabs = [{
  id: "compradores",
  label: "Para Compradores",
  title: "Preguntas frecuentes para compradores",
  items: buyerFaqs
}, {
  id: "marcas",
  label: "Para Marcas",
  title: "Preguntas frecuentes para marcas",
  items: brandFaqs
}];
export default function HelpCenter() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section className="content-container border-b border-black/10 py-14 md:py-20"><p className="text-[11px] uppercase tracking-[0.24em] text-black/45">Centro de ayuda</p><h1 className="mt-4 max-w-3xl text-3xl font-lealti-light leading-tight text-black md:text-5xl">Ayuda y preguntas frecuentes</h1><p className="mt-5 max-w-3xl text-base leading-relaxed text-black/70 md:text-lg">Resolvemos lo más importante antes, durante y después de tu compra en Lealti. Encontrá información para compradores y para marcas en una misma vista, con una lectura clara y directa.</p></section>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Tab.List className="grid w-full grid-cols-1 gap-2 border-b border-black/15 pb-4 sm:grid-cols-2">{tabs.map(_temp2)}</Tab.List>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section className="content-container py-10 md:py-14"><Tab.Group>{t1}<Tab.Panels className="pt-8">{tabs.map(_temp4)}</Tab.Panels></Tab.Group></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="max-w-4xl"><p className="text-[11px] uppercase tracking-[0.24em] text-black/45">Soporte centralizado</p><h2 className="mt-4 text-2xl font-lealti-light md:text-3xl">¿Necesitás ayuda con un caso puntual?</h2><p className="mt-4 text-base leading-relaxed text-black/70 md:text-lg">Nuestro soporte está disponible por chat, email y WhatsApp, con atención todos los días, 24 horas.</p></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <a href="https://wa.me/59896947466" target="_blank" rel="noreferrer" className="flex min-h-[110px] flex-col justify-between border border-black/20 p-5 transition hover:border-black"><div className="flex items-center gap-2 text-black"><PiWhatsappLogo className="h-5 w-5" /><p className="text-xs uppercase tracking-[0.2em]">WhatsApp</p></div><p className="text-sm text-black/70">+598 96 947 466</p></a>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <a href="mailto:soporte@lealti.com" className="flex min-h-[110px] flex-col justify-between border border-black/20 p-5 transition hover:border-black"><div className="flex items-center gap-2 text-black"><PiEnvelopeSimple className="h-5 w-5" /><p className="text-xs uppercase tracking-[0.2em]">Email</p></div><p className="text-sm text-black/70">soporte@lealti.com</p></a>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="bg-white text-black">{t0}{t2}<section className="content-container border-t border-black/10 py-10 md:py-14">{t3}<div className="mt-8 grid grid-cols-1 gap-3 md:grid-cols-3">{t4}{t5}<div className="flex min-h-[110px] flex-col justify-between border border-black/20 p-5"><div className="flex items-center gap-2 text-black"><PiChatCircleDots className="h-5 w-5" /><p className="text-xs uppercase tracking-[0.2em]">Chat web</p></div><p className="text-sm text-black/70">Disponible 24/7 en la experiencia Lealti.</p></div></div></section></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}
function _temp4(tab_0) {
  return <Tab.Panel key={tab_0.id}><div className="mb-6"><h2 className="text-2xl font-lealti-light text-black md:text-3xl">{tab_0.title}</h2></div><div className="border-y border-black/15">{tab_0.items.map(_temp3)}</div></Tab.Panel>;
}
function _temp3(item) {
  return <Disclosure as="div" key={item.question} className="border-b border-black/15 last:border-b-0">{t0 => {
      const {
        open
      } = t0;
      return <><Disclosure.Button className="flex w-full items-start justify-between gap-4 px-0 py-5 text-left"><span className="pr-8 text-base text-black md:text-lg">{item.question}</span><PiCaretDown className={`mt-1 h-5 w-5 shrink-0 text-black/60 transition-transform ${open ? "rotate-180" : ""}`} /></Disclosure.Button><Disclosure.Panel className="pb-6 pr-1"><p className="max-w-4xl text-sm leading-7 text-black/70 md:text-base">{item.answer}</p></Disclosure.Panel></>;
    }}</Disclosure>;
}
function _temp2(tab) {
  return <Tab key={tab.id} className={_temp}>{tab.label}</Tab>;
}
function _temp(t0) {
  const {
    selected
  } = t0;
  return `w-full border px-5 py-3 text-left text-xs uppercase tracking-[0.2em] transition ${selected ? "border-black bg-black text-white" : "border-black/20 bg-white text-black hover:border-black/45"}`;
}